<template>
  <b-overlay
    :show="busy"
    no-wrap
  >
    <template #overlay>
      <div
        v-if="processing"
        class="text-center p-3 bg-primary text-light rounded"
      >
        <div class="mb-2">
          {{ busymsg }}
        </div>
        <b-spinner
          type="grow"
          label="Loading..."
        />
      </div>
    </template>
  </b-overlay>
</template>

<script>
import {
  BOverlay, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BOverlay, BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    busyStatus: {
      type: Boolean,
      required: true,
    },
    processingStatus: {
      type: Boolean,
      required: true,
    },
    busyText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      busy: false,
      processing: false,
      busymsg: '',
    }
  },
  watch: {
    busyStatus: {
      handler() {
        this.busy = this.busyStatus
      },
    },
    processingStatus: {
      handler() {
        this.processing = this.processingStatus
      },
    },
    busyText: {
      handler() {
        this.busymsg = this.busyText
      },
    },
  },
  methods: {
    onCancel() {
      this.$emit('skipCancelTriggered')
    },
    onOK() {
      this.$emit('skipOKTriggered')
    },
  },
}
</script>

<style lang="scss">
.cancel-btn {
  margin-right: 20px !important;
  margin-top: 10px;
}
</style>
